import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useCallback } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import api, { STATUS_CODE } from "src/framework/providers/api";
import { Projeto } from "../../types";
import { useHistory } from "react-router-dom";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalClonarProjetoParams {
    open: boolean;
    closeModal: () => void;
    projeto?: Projeto;
    onSuccess: ()=>void;
}

export interface RequestClonagem {
    estado_id: string;
    servico?: string;
    valor?: number;
    valor_servico?: number;
    valor_servico_pis_cofins?: number;
    componentes: ComponenteClonagem[];
    potencia: number;
    projeto_original_id: number;
    segmento?: string | null;
    reativar_projeto?: boolean;
}
export interface ComponenteClonagem {
    id: number;
}

export const ModalClonarProjeto: FC<ModalClonarProjetoParams> = ({ onSuccess, open, closeModal, projeto }) => {
    const history = useHistory();

    const onConfirm = useCallback(async () => {
        if (!projeto?.codigo_venda) return;
        if (!projeto?.id) return;

        const payload = {
            projeto_original_id: projeto.id,
        }

        const result = await api.post({
            url: "/projetos/clonagem",
            data: payload
        })

        if (result.statusCode === STATUS_CODE.CREATED) {
            closeModal();

            const novoCodigoVenda = result.data?.[0]?.codigo_venda

            notifierStore.setNotifier({
                title: "Sucesso!",
                content: [
                    'O projeto foi clonado com sucesso.',
                    `O novo projeto foi criado com o código ${novoCodigoVenda}`],
                onClose: () => {
                    notifierStore.setOpen(false);
                    onSuccess();
                },
                timeOut: 4000,
                onFinishTimeout: () => {
                    notifierStore.setOpen(false);
                    onSuccess();
                }
            })
            notifierStore.setOpen(true);
        }
    }, [closeModal, onSuccess, projeto?.codigo_venda, projeto?.id, history])

    return (
        <Dialog
            open={open}
            onClose={closeModal}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"p"}>Ao clonar este projeto, os cálculos serão refeitos automaticamente, considerando os itens e regras atualmente disponíveis e a tabela de preços vigente para os componentes do projeto original. Os descontos serão removidos</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Fechar"
                    onClick={closeModal}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Confirmar"
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}

